'use client';

import React, { createContext, useContext, type ReactNode } from 'react';
import type { Store } from '@src/types/types';

interface StoreContextType {
  store: Store;
}

const StoreContext = createContext<StoreContextType | undefined>(undefined);

export const useStore = (): StoreContextType => {
  const context = useContext(StoreContext);
  if (context === undefined) {
    throw new Error('useStore must be used within a StoreProvider');
  }
  return context;
};

interface StoreProviderProps {
  store: Store;
  children: ReactNode;
}

export const StoreProvider: React.FC<StoreProviderProps> = ({ store, children }) => {
  const value = { store };

  return <StoreContext.Provider value={value}>{children}</StoreContext.Provider>;
};
